import { useTranslation } from 'react-i18next'

import { copies, InputWithLabel, TermsAndConditionsCheckbox } from '@reveni-io/reveni-ui'

import { actionTypes, inputMaxLengths } from '@/constants'
import useCustomCopy from '@/hooks/useCustomCopy/useCustomCopy'

import GiftRecipientFields from './GiftRecipientFields/GiftRecipientFields'
import GiftReturnToggle from './GiftReturnToggle/GiftReturnToggle'
import OrderRecoveryHint from './OrderRecoveryHint/OrderRecoveryHint'
import TransactionButtons from './TransactionButtons/TransactionButtons'
import { isFormValid } from './helpers'
import * as Styles from './styles'

const OrderForm = ({
  handleSubmit,
  orderNumber,
  setOrderNumber,
  identifier,
  setIdentifier,
  transactionTypes,
  orderLoading,
  type,
  merchantCountry,
  allowsUnifiedFlow,
  isGiftReturn,
  giftRecipient,
  onGiftRecipientChange,
  onReturnToRegularOrder,
  allowsGiftReturns,
  onReturnToGiftReturn,
  skipIdentifierValidation,
  orderRecoveryPath,
}) => {
  const { i18n } = useTranslation()

  const orderNumberLabel = useCustomCopy('start_screen.order_number') || copies[i18n.language]?.texts.orderNumber
  const emailPostcodeLabel =
    useCustomCopy('start_screen.email_postcode') || copies[i18n.language]?.texts.emailOrPostCode

  const shouldShowIdentifier = !(isGiftReturn && skipIdentifierValidation)
  const shouldShowOrderRecoveryLink = Boolean(orderRecoveryPath) && shouldShowIdentifier

  const checkIsFormValid = () => {
    return isFormValid({ orderNumber, identifier, isGiftReturn, giftRecipient, skipIdentifierValidation })
  }

  return (
    <form onSubmit={handleSubmit}>
      <Styles.Fields>
        <InputWithLabel
          label={orderNumberLabel}
          fullWidth
          onChange={e => setOrderNumber(e.target.value)}
          value={orderNumber}
          name="orderNumber"
          maxLength={inputMaxLengths.orderNumber}
          helperText={shouldShowOrderRecoveryLink && <OrderRecoveryHint path={orderRecoveryPath} />}
        />
        {shouldShowIdentifier && (
          <InputWithLabel
            onChange={e => setIdentifier(e.target.value)}
            value={identifier}
            name="identifier"
            label={emailPostcodeLabel}
            maxLength={inputMaxLengths.orderEmail}
            fullWidth
          />
        )}
      </Styles.Fields>

      {isGiftReturn && <GiftRecipientFields giftRecipient={giftRecipient} onChange={onGiftRecipientChange} />}

      <Styles.ConditionsContainer>
        <TermsAndConditionsCheckbox
          language={i18n.language}
          isUKMerchant={merchantCountry === 'GB'}
          withCookies
          source="returns"
          withoutCheckbox
        />
      </Styles.ConditionsContainer>
      <TransactionButtons
        allowedTransactionTypes={transactionTypes}
        isFormValid={checkIsFormValid}
        orderLoading={orderLoading}
        returnIsLoading={type === actionTypes.refund && orderLoading}
        exchangeIsLoading={type === actionTypes.exchange && orderLoading}
        handleSubmit={handleSubmit}
        allowsUnifiedFlow={allowsUnifiedFlow}
        isGiftReturn={isGiftReturn}
      />
      <GiftReturnToggle
        isGiftReturn={isGiftReturn}
        onReturnToRegularOrder={onReturnToRegularOrder}
        allowsGiftReturns={allowsGiftReturns}
        onReturnToGiftReturn={onReturnToGiftReturn}
      />
    </form>
  )
}

export default OrderForm
